import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  background: `linear-gradient(180deg, ${theme.palette.common.black} 0%, ${theme.palette.common.black} 39.45%, ${theme.palette.background.default})`,
  padding: theme.spacing(14, 8),
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(14, 3),
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(14, 2),
  },

  '& .ASImageContainer': {
    width: '100%',
    height: theme.typography.pxToRem(595),
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      height: theme.typography.pxToRem(286),
    },
  },
}));

export default StyledBox;
